import {
    HouseIcon,
    BellSimpleIcon,
    GlobeIcon,
    CarIcon,
    ClipboardTextIcon,
    UserFocusIcon,
} from '@phosphor-icons/react';
import { AppRoutes } from './routes';
import { SecurityCameraIconMirrored } from '@/utils/icons';
import { Icon } from '@phosphor-icons/react';

export interface NavLink {
    path: string;
    icon: Icon;
    labelKey: string;
}

export interface NavDropdown {
    icon: Icon;
    labelKey: string;
    items: NavLink[];
}

export type NavItem = NavLink | NavDropdown;

export function isNavDropdown(item: NavItem): item is NavDropdown {
    return 'items' in item;
}

export const NAVIGATION_BAR_CONFIG = {
    logoSrc: '/images/conntour_logo_white.svg',
    userAvatar: {
        name: 'User',
    },
    get navLinks(): NavItem[] {
        return [
            {
                path: AppRoutes.HOME,
                icon: HouseIcon,
                labelKey: 'navigation.home',
            },
            {
                path: AppRoutes.SOURCES,
                icon: SecurityCameraIconMirrored,
                labelKey: 'navigation.sources',
            },
            {
                path: AppRoutes.ALERT_RULES,
                icon: BellSimpleIcon,
                labelKey: 'navigation.alertRules',
            },
            {
                path: AppRoutes.REPORTS,
                icon: ClipboardTextIcon,
                labelKey: 'navigation.reports',
            },
            {
                icon: GlobeIcon,
                labelKey: 'navigation.directory',
                items: [
                    {
                        path: AppRoutes.PERSONS,
                        icon: UserFocusIcon,
                        labelKey: 'navigation.persons',
                    },
                    {
                        path: AppRoutes.VEHICLES,
                        icon: CarIcon,
                        labelKey: 'navigation.vehicles',
                    },
                ],
            },
        ];
    },
};
